<div class="details__wrapper">
    <div class="details__head">
        <div class="head__title">
            ...
        </div>
        <div class="head__info"></div>
    </div>
</div>

<style>
    .details__head {
        display: flex;
        justify-content: space-between;
        background-color: grey;
        padding: 10px;
        color: white;
    }
</style>